const P = (i) => {
  var s, u;
  const w = (s = i.level_1_menus) == null ? void 0 : s.map((a) => {
    var o;
    const n = [];
    return (o = a == null ? void 0 : a.level_2_menus) == null || o.map((t) => {
      var p, _, m, y, c, g, q, d, k;
      const C = (m = (_ = (p = t == null ? void 0 : t.image.images) == null ? void 0 : p[0]) == null ? void 0 : _.image) == null ? void 0 : m.url, f = (c = (y = t == null ? void 0 : t.image.images) == null ? void 0 : y[0]) == null ? void 0 : c.alt_text, h = (g = t == null ? void 0 : t.image.images) == null ? void 0 : g.map((r) => ({
        url: r == null ? void 0 : r.image.url,
        altText: r == null ? void 0 : r.alt_text,
        viewport: r == null ? void 0 : r.viewport
      }));
      n.push({
        title: t == null ? void 0 : t.title,
        imageUrl: C,
        imageList: h,
        overlayGradient: t.gradient_type,
        linearGradient: (q = t.linear_gradient) == null ? void 0 : q.color,
        link: t == null ? void 0 : t.link,
        queryParams: (d = t == null ? void 0 : t.query_params) == null ? void 0 : d.query_params,
        altText: f,
        subCategories: t && ((k = t == null ? void 0 : t.level_3_menus) == null ? void 0 : k.map((r) => {
          var x, T;
          return {
            title: r.title,
            url: r.link.url,
            target: r.link.target,
            queryParams: (T = (x = r.query_params) == null ? void 0 : x.query_params) != null && T.length ? r.query_params.query_params : r.link.query_params
          };
        }))
      });
    }), n;
  });
  return {
    navigations: (u = i.level_1_menus) == null ? void 0 : u.map((a, n) => ({
      allTitle: a.all_title,
      title: a.title,
      menuType: a.menu_type,
      menuId: a.menu_id,
      categories: w[n],
      url: a.link.url,
      viewport: a.viewport
    })),
    componentType: "mega_menu",
    activeRoute: i.activeRoute
  };
};
export {
  P as default
};
//# sourceMappingURL=navigationMenuTransformer.js.map
